<dialog-gala (clickClose)="askHideModal()">
  <span gala-dialog-titre>{{lgTrad.AFFRACES}}</span>
  <div>
    <div class="row">
      <div class="col-md-12">
        @if (!isEdition) {
          <select-filtre #selectRace [options]="listeRfRacesFiltre" [label]="lgTrad.RACES"
            [disabled]="!droitsAccess.write || isEdition" />
        }
      </div>
    </div>
    @if (formData) {
      <form [formGroup]="formData" autocomplete="off">
        <div class="row">
          <div class="col-md-12">
            @if (isEdition) {
              <select-gala formControlName="RFRACE" [options]="listeRfRaces" bindLabel="CORABO"
                container="#ateliers" [label]="lgTrad.RACES" [disabled]="true" />
            }
          </div>
        </div>
      </form>
    }
  </div>
  <div gala-dialog-actions>
    @if (droitsAccess.write) {
      <button mat-stroked-button color="primary" (click)="enregistrerRaces()"
      >{{lgTrad.ENR}}</button>
    }
    <button mat-stroked-button color="accent" (click)="askHideModal()">{{lgTrad.RET}}</button>
  </div>
</dialog-gala>